(function () {
    'use strict';
    angular.module('app.nav', ['app.services', 'ngMaterial', 'app.context', 'rx']);
})();
